export default __webpack_public_path__ + "static/media/34.d5b54571.png";